import moment from 'moment';

import axios from 'utils/axios';

// All care-stats windows are client-derived UTC instants, half-open [fromTS, toTS).
// weekStartDate (Monday, YYYY-MM-DD) is only sent when the range is a goal week —
// the response includes weeklyGoalHours only when it is present.
export async function getCustomRangeCareStatsForLoggedInUser(fromTS, toTS, weekStartDate) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/productivity/care-stats/custom-time-range`, {
            params: {
                fromTS,
                toTS,
                weekStartDate
            }
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function getMonthlyInteractionsForLoggedInUser() {
    // the current calendar month in browser-local time, half-open [fromTS, toTS)
    const fromTS = moment().startOf('month').valueOf();
    const toTS = moment().startOf('month').add(1, 'month').valueOf();
    try {
        const response = await axios.get(`/api/org-id/{orgId}/productivity/care-stats/monthly-interactions`, {
            params: {
                fromTS,
                toTS
            }
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}
